import React, { useContext } from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import images from "../../global-styles/images";
import { IconWithToolTip } from "../common";
import { useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_MANAGER,
  ROLE_USER_MEMBER,
  ROLE_USER_SUPERADMIN,
} from "../../model";
import {
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
} from "../../utils/config";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const SideMenu = (props: any) => {
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }

  const { userInfo, setFilterDate } = useContext(UserContext) as UserLoginInfo;

  const userRole = userInfo.userDetails
    ? userInfo.userDetails.userRole
      ? userInfo.userDetails.userRole.length > 0
        ? userInfo.userDetails.userRole
        : ""
      : ""
    : "";

  let menuList = [
    {
      name: "Dashboard",
      icon: "icon-dashboard",
      url: "dashboard",
      className: "dashboard-menu-side",
      forAdmin: true,
      forManager: true,
      forMember: true,
      appLevelEnableFeature: true,
      orgLevelEnableFeature: true,
    },
    {
      name: "Feedback & Tickets",
      icon: "icon-feedback",
      url: "feedback",
      className: "feedback-menu-side",
      forAdmin: true,
      forManager: true,
      forMember: true,
      appLevelEnableFeature: true,
      orgLevelEnableFeature: true,
    },
    // {
    //   name: "Tickets",
    //   icon: "icon-feedback",
    //   url: "tickets",
    //   className: "ticket-menu-side",

    //   forAdmin: false,
    //   forManager: true,
    // },
    {
      name: "Manage Users",
      icon: "icon-user",
      className: "user-menu-side",

      url: "users",
      forAdmin: true,
      forManager: true,
      forMember: false,
      appLevelEnableFeature: true,
      orgLevelEnableFeature: true,
      notForSso: true,
    },
    // {
    //   name: "Manage Products",
    //   icon: "icon-products",
    //   className: "products-menu-side",

    //   url: "products",
    //   forAdmin: true,
    //   forManager: true,
    //   forMember: false,
    //   appLevelEnableFeature:
    //     enableFeedback || enableBugReport || enableFeatureRequest,
    //   orgLevelEnableFeature:
    //     userEnabledFeatures?.enableFeedback ||
    //     userEnabledFeatures?.enableBugReport ||
    //     userEnabledFeatures?.enableFeatureRequest,
    // },
    {
      name: "Manage Accounts",
      icon: "icon-platforms",
      url: "accounts",
      className: "configuration-menu-side",
      forAdmin: true,
      forManager: true,
      forMember: false,
      appLevelEnableFeature: true,
      orgLevelEnableFeature: true,
    },
    // {
    //   name: "Manage Chatbot",
    //   icon: "icon-devices",
    //   url: "chatbots",
    //   className: "chatbot-menu-side",

    //   forAdmin: true,
    //   forManager: false,
    //   forGenerativeAI: true,
    // },
    // {
    //   name: "Manage Groups",
    //   icon: "icon-group",
    //   url: "groups",
    //   className: "groups-menu-side",

    //   forAdmin: true,
    //   forManager: false,
    //   appLevelEnableFeature: true,
    //   orgLevelEnableFeature: true,
    // },
    {
      name: "Settings",
      icon: "icon-settings",
      url: "settings",
      className: "settings-menu-side",
      forAdmin: true,
      forManager: false,
      forMember: false,
      appLevelEnableFeature: true,
      orgLevelEnableFeature: true,
    },
    // {
    //   name: "Manage Platforms",
    //   icon: "icon-platforms",
    //   url: "dashboard",
    // },
    // { name: "Manage Devices", icon: "icon-devices", url: "dashboard" },
    // { name: "Campaigns", icon: "icon-campaigns", url: "dashboard" },
    // { name: "Test Suites", icon: "icon-test-suites", url: "dashboard" },
    // { name: "Test Cases", icon: "icon-test-cases", url: "dashboard" },
    // {
    //   name: "Reports",
    //   icon: "icon-reports",
    //   url: "dashboard",
    // },
    // {
    //   name: "Settings",
    //   icon: "icon-settings",
    //   url: "dashboard",
    // },
  ];

  if (userRole === ROLE_USER_SUPERADMIN) {
    const superAdminMenu = {
      name: "Manage Organizations",
      icon: "icon-settings",
      url: "manage-organizations",
      className: "settings-menu-side",
      forAdmin: true,
      forManager: false,
      forMember: false,
      appLevelEnableFeature: true,
      orgLevelEnableFeature: true,
    };

    menuList = [...menuList, superAdminMenu];
  }

  const location = useLocation();

  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const menuChange = () => {
    setFilterDate({
      startDate: "",
      endDate: "",
    });
  };

  return (
    <Box component="div" className={open ? "sidenav active" : "sidenav"}>
      <Box className="sidenav-logo">
        <Tooltip
          title={open ? "hide side bar" : "expand side bar"}
          placement="top"
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className="sidenav-toggle"
          >
            <img className="toggle-icon" src={images.toggleIcon} />
            <img className="toggle-icon-mobile" src={images.toggleMobile} />
          </IconButton>
        </Tooltip>
        {/* <img className='logo' src={Sling} /> */}
      </Box>

      <Drawer variant="permanent" open={open}>
        <List>
          {/* <Link activeClassName="active" href="/feedback">
        Home
      </Link> */}

          {menuList.map((menu: any) => {
            if (menu.notForSso && userInfo.isSsoUser) {
              return <div />;
            }

            if (
              (((userRole === ROLE_USER_ADMIN ||
                userRole === ROLE_USER_SUPERADMIN) &&
                menu.forAdmin) ||
                (userRole == ROLE_USER_MANAGER && menu.forManager) ||
                (userRole == ROLE_USER_MEMBER && menu.forMember)) &&
              menu.appLevelEnableFeature &&
              menu.orgLevelEnableFeature &&
              !(menu.notForSso && userInfo.isSsoUser)
            ) {
              return (
                <ListItem
                  disablePadding
                  key={menu.name}
                  className={menu.className}
                >
                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    component={Link}
                    to={"/" + menu.url}
                    selected={"/" + menu.url === location.pathname}
                  >
                    <ListItemButton onClick={menuChange}>
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          justifyContent: "center",
                        }}
                      >
                        {/* {props.addTooltipIcon(menu.name, menu.icon)} */}
                        <IconWithToolTip
                          message={open ? "" : menu.name}
                          iconName={menu.icon}
                        />
                        {/* <i className={menu.icon} /> */}
                      </ListItemIcon>
                      <ListItemText
                        primary={menu.name}
                        sx={{ display: open ? "block" : "none" }}
                      />
                    </ListItemButton>
                  </ListItem>
                </ListItem>
              );
            }

            // if (
            //   ((menu.forAdmin &&
            //     !menu.forGenerativeAI &&
            //     (userRole === ROLE_USER_ADMIN ||
            //       userRole === ROLE_USER_SUPERADMIN)) ||
            //     !menu.forAdmin) &&
            //   menu.appLevelEnableFeature &&
            //   menu.orgLevelEnableFeature
            // ) {
            //   return (
            //     <ListItem
            //       disablePadding
            //       key={menu.name}
            //       className={menu.className}
            //     >
            //       <ListItem
            //         disablePadding
            //         sx={{ display: "block" }}
            //         component={Link}
            //         to={"/" + menu.url}
            //         selected={"/" + menu.url === location.pathname}
            //       >
            //         <ListItemButton onClick={menuChange}>
            //           <ListItemIcon
            //             sx={{
            //               minWidth: 0,
            //               justifyContent: "center",
            //             }}
            //           >
            //             {/* {props.addTooltipIcon(menu.name, menu.icon)} */}
            //             <IconWithToolTip
            //               message={open ? "" : menu.name}
            //               iconName={menu.icon}
            //             />
            //             {/* <i className={menu.icon} /> */}
            //           </ListItemIcon>
            //           <ListItemText
            //             primary={menu.name}
            //             sx={{ display: open ? "block" : "none" }}
            //           />
            //         </ListItemButton>
            //       </ListItem>
            //     </ListItem>
            //   );
            // }

            // if (
            //   menu.forMember &&
            //   userRole === ROLE_USER_MANAGER &&
            //   menu.appLevelEnableFeature &&
            //   menu.orgLevelEnableFeature
            // ) {
            //   return (
            //     <ListItem disablePadding key={menu.name}>
            //       <ListItem
            //         disablePadding
            //         sx={{ display: "block" }}
            //         component={Link}
            //         to={"/" + menu.url}
            //         selected={"/" + menu.url === location.pathname}
            //       >
            //         <ListItemButton>
            //           <ListItemIcon
            //             sx={{
            //               minWidth: 0,
            //               justifyContent: "center",
            //             }}
            //           >
            //             {/* {props.addTooltipIcon(menu.name, menu.icon)} */}
            //             <IconWithToolTip
            //               message={open ? "" : menu.name}
            //               iconName={menu.icon}
            //             />
            //             {/* <i className={menu.icon} /> */}
            //           </ListItemIcon>
            //           <ListItemText
            //             primary={menu.name}
            //             sx={{ display: open ? "block" : "none" }}
            //           />
            //         </ListItemButton>
            //       </ListItem>
            //     </ListItem>
            //   );
            // }

            // if (
            //   menu.forAdmin &&
            //   menu.forGenerativeAI &&
            //   enableGenerativeAI &&
            //   menu.appLevelEnableFeature &&
            //   menu.orgLevelEnableFeature
            // ) {
            //   return (
            //     <ListItem
            //       disablePadding
            //       key={menu.name}
            //       className={menu.className}
            //     >
            //       <ListItem
            //         disablePadding
            //         sx={{ display: "block" }}
            //         component={Link}
            //         to={"/" + menu.url}
            //         selected={"/" + menu.url === location.pathname}
            //       >
            //         <ListItemButton onClick={menuChange}>
            //           <ListItemIcon
            //             sx={{
            //               minWidth: 0,
            //               justifyContent: "center",
            //             }}
            //           >
            //             {/* {props.addTooltipIcon(menu.name, menu.icon)} */}
            //             <IconWithToolTip
            //               message={open ? "" : menu.name}
            //               iconName={menu.icon}
            //             />
            //             {/* <i className={menu.icon} /> */}
            //           </ListItemIcon>
            //           <ListItemText
            //             primary={menu.name}
            //             sx={{ display: open ? "block" : "none" }}
            //           />
            //         </ListItemButton>
            //       </ListItem>
            //     </ListItem>
            //   );
            // }
          })}
        </List>
      </Drawer>
    </Box>
  );
};

export default SideMenu;
